export default "__VITE_ASSET__R$5yhU9Z__"